
import styles from "../AccountingPage.module.scss";
import { useEffect, useState } from 'react'
import Notification from "utils/Notifications";
import { Button } from 'components'
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";

import { getCheckData, PostCheckData, DeleteCheckData, PatchCheckData } from "service/AccountingService";
import ModalWindow from "hooks/ModalWindow/ModalWindow";


const CheckContent = ({ render, setRender, id }) => {
  const componentRef = useRef();
  const [openModal, setOpenModal] = useState(false);


  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });


  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [data, setData] = useState([]);
  const getData = async (id) => {
    try {
      let response = await getCheckData(id, data);
      setData(response.data);

    } catch (error) {
      console.log("onoxo")
    }
  };
  const [check_data, setCheck] = useState("");
  const [base, setBase] = useState("");



  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!check_data) {
      setNotify({
        isOpen: true,
        message: "Введите счет!",
        type: "error",
      });

    }

    else if (!base) {
      setNotify({
        isOpen: true,
        message: "Введите основание счета!",
        type: "error",
      });

    }

    else {
      const formData = new FormData();
      formData.append('check_data', check_data);
      formData.append('base', base);

      let data = await PostCheckData(id, formData);

      getData();


      setCheck("");
      setBase("");

      setOpenModal(false)

      setNotify({
        isOpen: true,
        message: "Счет успешно создан!",
        type: "success",
        sound: "success"
      });
      setRender(true)
    }

  };

  useEffect(() => {

    getData(id);

    setRender(false);



  }, [render]);

const [searchCheck, setSearchCheck] = useState("");

  const setSearchCheckById = (id) => {
    setSearchCheck(id);
  };




 const filteredData = Array.isArray(data)
  ? data.filter((item) => {
      const matchCheck = !searchCheck || item.id === Number(searchCheck);
      return matchCheck;
    })
  : [];

  const clearFilters = () => {
    setSearchCheck('');
    setCurrentPage(1);
  };


  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);



  const [editRowId, setEditRowId_Set] = useState(null);
  const [check_edit, setCheckEdit] = useState('');
  const [base_edit, setBaseEdit] = useState('');


  const setEditRowId = (item) => {
    setCheckEdit(item.check_data)
    setBaseEdit(item.base)
    setEditRowId_Set(item.id)
  };


  const onDelete = async (id) => {
    let data = await DeleteCheckData(id);
    setNotify({
      isOpen: true,
      message: "Счет успешно удален!",
      type: "success",
      sound: "success"
    });
    setRender(true)
  };

  const onSave = async (id) => {
    const formData = new FormData();
    formData.append('check_data', check_edit);
    formData.append('base', base_edit);

    let data = await PatchCheckData(id, formData);


    getData()
    setCheckEdit("");
    setBaseEdit("");
    setOpenModal(false)

    setNotify({
      isOpen: true,
      message: "Счет успешно изменен!",
      type: "success",
      sound: "success"
    });
    setRender(true)
    setEditRowId_Set(null);
  };



  return (
    <>

      <div className={styles.content_header}>

        <h2 className={styles.project__h}>Счета</h2>
        <button className={styles.btn_print} onClick={handlePrint}>Печать 🖨️ </button>


        <Button className={styles.btn_pin} onClick={() => setOpenModal(true)} >
          Добавить счет
        </Button>
      </div>

      <div className={styles.div_search}>
        <div className={styles.div_check_search}>
          <div>
            <label>Счет:</label>
            <select
              value={searchCheck}
              onChange={(e) => setSearchCheckById(e.target.value)}
            >
              <option value="">Выберите Счет</option>
              {Array.isArray(data) && data.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.check_data}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label>Основание:</label>
            <select
              value={searchCheck}
              onChange={(e) => setSearchCheckById(e.target.value)}
            >
              <option value="">Выберите основание</option>
              {Array.isArray(data) && data.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.base}
                </option>
              ))}
            </select>
          </div>
        </div>

        <Button onClick={clearFilters} className={styles.clear__button} >
          Очистить 
        </Button>

      </div>

      <table ref={componentRef} className={styles.table__wrapper}>
        <thead className={styles.table__head}>
          <tr className={styles.table__row}>
            <th className={styles.table__item}>№</th>

            <th className={styles.table__item}>
              <span className={styles.table__title}>Счет</span>
            </th>
            <th className={styles.table__item}>
              <span className={styles.table__title}>Основание </span>
            </th>

            <th className={styles.table__item__nav} >
              <span className={styles.table__title}>Действия</span>
            </th>
          </tr>
        </thead>

        <tbody className={styles.table__body}>
          {currentItems.map((item, index) => (

            <tr className={styles.table__row} key={item.id}>
              <td className={styles.table__item}>
                <span className={styles.table__title}>
                  {index + 1 + (currentPage - 1) * itemsPerPage}
                </span>
              </td>
              {editRowId === item.id ? (
                <>
                  <td className={styles.table__item}>
                    <input
                      type="text"
                      value={check_edit}
                      onChange={(e) => setCheckEdit(e.target.value)}
                      placeholder="Введите номер счета"
                      className={styles.edit_input}
                    />
                  </td>

                  <td className={styles.table__item}>
                    <input
                      type="text"
                      value={base_edit}
                      onChange={(e) => setBaseEdit(e.target.value)}
                      placeholder="Основание"
                      className={styles.edit_input}
                    />
                  </td>

                  <td className={styles.table__item__nav} >
                    <div className={styles.table__item__div}>
                      <button onClick={() => onSave(item.id)} className={styles.saveBtn}>💾 </button>
                      <button onClick={() => setEditRowId_Set(null)} className={styles.cancelBtn}>
                        ❌
                      </button>
                      <button onClick={() => onDelete(item.id)} className={styles.deleteBtn}>🗑️</button>
                    </div>
                  </td>

                </>
              ) : (
                <>
                  <td className={styles.table__item}>
                    <span className={styles.table__title} style={{ fontWeight: '700' }}>
                      {item.check_data}
                    </span>
                  </td>
                  <td className={styles.table__item}>
                    <span className={styles.table__title}>{item.base}</span>
                  </td>

                  <td className={styles.table__item}>
                    <div className={styles.table__item__div}>
                      <button onClick={() => setEditRowId(item)} className={styles.editBtn}>✏️ </button>
                    </div>
                  </td>
                </>
              )}
            </tr>
          ))}

          {/* Итого */}

        </tbody>
        <div className={styles.pagination}>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <button
              key={page}
              onClick={() => setCurrentPage(page)}
              style={{
                padding: '5px 10px',
                background: currentPage === page ? '#736CED' : '#f0f0f0',
                color: currentPage === page ? '#fff' : '#000',
                border: '1px solid #ccc',
                borderRadius: "6px",
                cursor: 'pointer',
              }}
            >
              {page}
            </button>
          ))}
        </div>



      </table>

      <ModalWindow
        openModal={openModal}
        setOpenModal={setOpenModal}
        modalText={'Новый счёт'}
      >
        <>
          <div className={styles["note-input"]}>

            <form onSubmit={handleSubmit} >
              <div className={styles.form_input}>
                <input
                  type="text"
                  placeholder="Введите счет:"

                  value={check_data}
                  name="check"
                  onChange={(e) => setCheck(e.target.value)}
                />

                <input
                  type="text"
                  placeholder="Основание:"

                  value={base}
                  name="source"
                  onChange={(e) => setBase(e.target.value)}
                />


              </div>


              <div className={styles.create_footer}>


                <button
                  type="submit"
                  className={styles.open_btn_sub}

                >
                  Создать
                </button>
              </div>
            </form>
          </div>
          <Button
            onClick={() => setOpenModal(false)}
            className={styles.close_btn_sub}
          >
            {" "}
            Закрыть
          </Button>
        </>
      </ModalWindow>
      <Notification notify={notify} setNotify={setNotify} />



    </>


  );
};

export default CheckContent;
